import { render, staticRenderFns } from "./Auswertung.vue?vue&type=template&id=9f9aaa0a&"
import script from "./Auswertung.vue?vue&type=script&lang=js&"
export * from "./Auswertung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports